export function deleteEntityPermission(permissions, folder) {
    if (permissions) {
        switch (folder) {
            case 'attorneys':
                return permissions.attorney_archive
            case 'liabilities':
                return permissions.liability_archive
            case 'mp_pip_um':
                return permissions.medpay_pip_archive
            case 'um':
                return permissions.um_archive
            case 'major_meds':
                return permissions.major_med_archive            
            default:
                return false;
        }
    }

    return false
}


export function viewTabPermission(tabs, permissions) {
    if (permissions && tabs) {

        // filter tabs based on permissions; some tabs have no need for permissions

        const hasViewPermission = (value) => value === true || value === 1 || value === '1'
        const matches = tabs.filter((item) => {
            if (!item) {
                return false
            }
            if (item.permissions === 'skip') {
                return true
            }
            return hasViewPermission(permissions[`${item.permissions}view`])
        })

        return matches
        
    }

    return false
}

export function editTabPermission(tab, permissions) {
    if (permissions && tab) {
        return true
    }

    return false
}